<template>
  <div class="station-board-container">
    <div class="glow"></div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts"></script>

<style scoped lang="postcss">
.station-board-container {
  @apply w-full h-full bg-base-gradient flex flex-col relative;

  .glow {
    background-image: url('@/assets/background-glow.png');
    background-size: cover;
    @apply absolute z-0 top-0 right-0 w-[390px] h-[401px] md:w-[602px] md:h-[555px] pointer-events-none;
  }

  .content {
    @apply flex-grow flex-col flex z-[1];
  }
}
</style>
